import { toast } from "react-toastify";
import api from "../api";
import {
  GET_ERRORS,
  SET_AVATAR,
  SET_SERVICE_REGISTERED,
  SET_USER,
  SET_ERROR,
  UPDATE_BALANCE
} from "./types";

// This function is used to register a user
export const registerUser =
  (userData, history, setClickStatus, onFailure) => (dispatch) => {
    const queryString = window.location.search
    // console.log(queryString, 'queryString')
    const referrerIdMatch = queryString.match(/\?([^&]*)/)
    const referrerId = referrerIdMatch ? referrerIdMatch[1] : null
    // console.log(referrerId, 'referrerValue in frontend')
    const registrationData = { ...userData, referrerId }

    api
      .post("/auth/register", registrationData)
      .then((res) => {
        // console.log(res, 'register')
        if (res && res.data.success) {
          // The backend still sends the verification email here (unchanged).
          // Instead of blocking the user on a "verify first" screen, we log
          // them in with the token returned from registration so they can
          // continue the rest of the sign-up flow and verify their email later.
          const token = res?.data?.data?.token || res?.data?.token;
          const newUser = res.data.data?.user || res.data.user || {};
          if (token) {
            localStorage.setItem("jwtToken", token);
            dispatch(setCurrentUser(newUser));
          }

          if (res.data.balance !== undefined) {
            dispatch({
              type: UPDATE_BALANCE, // Use the constant action type
              payload: res.data.balance,
            });
          }
          toast.success("Successfully Registered.", {
            position: "top-center",
            containerId: "main",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

          toast.success(
            "We've emailed you a verification link — you can verify anytime. Let's finish setting up your profile.",
            {
              position: "top-center",
              containerId: "main",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            }
          );

          // Navigate to the next step ONLY now that the registration response
          // has succeeded and the user is actually created + logged in. (Doing
          // this reactively on `isAuthenticated` would wrongly redirect an
          // already-logged-in visitor even when registration fails / backend
          // is down.)
          if (token) {
            history.push(newUser.isServiceRegisted ? "/dashboard" : "/service");
          }
        } else if (onFailure) {
          onFailure();
        }
        setClickStatus(false);
      })
      .catch((err) => {
        // Handle errors. Prefer the backend's own message when it sent one
        // (e.g. a failed captcha check), otherwise fall back to a generic one.
        const backendMessage = err?.response?.data?.message;
        let message = err.message.match(/422/i)
          ? "User already exists with the same email."
          : backendMessage || "Internal Server Error(s)";

        if (onFailure) onFailure();

        toast.error(message, {
          position: "top-center",
          containerId: "main",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        dispatch({
          type: GET_ERRORS,
          payload: "Database error!",
        });
        setClickStatus(false);
      });
  };


// This function is used to login a user 
export const loginUser = (userData, history, setClicked, onFailure) => (dispatch) => {
  // Make an API call to the server

  // console.log('userData', userData)
  api
    .post("/auth/login", userData)
    .then((res) => {
      // If the response is successful, store the token and user data in localStorage
      if (res.data.success) {
        const token = res.data.data.token;
        localStorage.setItem("jwtToken", token);
        // localStorage.setItem("user", JSON.stringify(res.data.data.user));
        dispatch(setCurrentUser(res.data.data.user));
        // Show a success toast message
        toast.success("Logged in Successfully", {
          position: "top-center",
          containerId: "main",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
      setClicked(false);
    })
    .catch((err) => {
      console.log('err', err)
      // Get error message
      let message;

      // Dispatch an error action
      dispatch({
        type: SET_ERROR,
        payload: "",
      });
      if (err.message.match(/400/i)) {
        // 400 also covers a rejected captcha, which sends its own message.
        message = err?.response?.data?.message || "You are not registered!";
      } else if (err.message.match(/401/i)) {
        message = "Your password is incorrect.";
      } else if (err.message.match(/403/i)) {
        message = "Your email is not verified yet.";
      } else {
        message = err?.response?.data?.message || "Internal Server Error(s)";
      }

      if (onFailure) onFailure();
      // Show an error toast message
      toast.error(message, {
        position: "top-center",
        containerId: "main",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      // setClicked(false);
    });
};

// This function is used to set the current user
export const setCurrentUser = (decoded_data) => ({
  type: SET_USER,
  payload: {
    decoded_data,
  },
});

// Flag the current user as having completed service onboarding.
export const setServiceRegistered = () => ({
  type: SET_SERVICE_REGISTERED,
});

// This function is used to set the avatar of the user
export const setAvatar = (avatar) => (dispatch) => {
  // Get the user data from localStorage
  // let tmp = JSON.parse(localStorage.user);
  // Set the avatar of the user
  // tmp["avatar"] = avatar;
  // Store the updated user data in localStorage
  // localStorage.setItem("user", JSON.stringify(tmp));
  // Dispatch an action with the updated user data
  dispatch({
    type: SET_AVATAR,
    payload: {
      avatar: avatar,
    },
  });
};

// This function is used to logout the user
export const logoutUser = () => (dispatch) => {
  // Remove the token and user data from localStorage
  localStorage.removeItem("jwtToken");
  localStorage.removeItem("user");
  // Clear the saved onboarding step so the next sign-up starts fresh.
  localStorage.removeItem("serviceStep");
  // Dispatch an action to set the current user to empty object
  dispatch(setCurrentUser({}));
  // Redirect the user to the login page
  // window.location.href = "/";
};

export const logoutOnUnload = () => (dispatch) => {
  // window.addEventListener("beforeunload", () => {
  //   dispatch(logoutUser());
  // });
};